<template>
  <section class="property-form-section">
    <div class="property-form-section-title text-overline text-medium-emphasis">{{ title }}</div>
    <!-- O que a seção faz, no estilo da explicação do Acesso (pedido do usuário). Sem a margem de lá: o
         espaço até o campo é o vão da seção (`PropertyFormLayout`), e com os dois somados ficava o dobro -->
    <p v-if="explain" class="text-body-2 text-medium-emphasis"><ontos-code-text :text="explain"/></p>
    <slot/>
  </section>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import CodeText from '@/components/shared/CodeText.vue'

/**
 * Uma seção da janela de propriedade — Identidade, Tipo, Comportamento, Cálculo… —: o título pequeno e
 * os campos embaixo, no ritmo do `PropertyFormLayout`. Antes tudo ficava misturado, sem agrupamento
 * nem título (relato do usuário).
 */
@Component({name: 'ontos-property-form-section', components: {'ontos-code-text': CodeText}})
class PropertyFormSection extends Vue {
  @Prop({type: String, required: true}) readonly title!: string
  /** A frase embaixo do título, para a seção que não se explica sozinha — as Opções permitidas, as regras. */
  @Prop({type: String, default: ''}) readonly explain!: string
}

export default toNative(PropertyFormSection)
</script>

<style scoped>
.property-form-section-title {
  line-height: 1.5;
}
</style>
